"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Power
 *
 * Given a number, find all it's positive powers.
 * e.g. for 2 it would be 2, 4, 8, 16....
 *      for 3 it would be 3, 9, 27, 81....
 */
// Public API
exports.default = function (start) {
  return (0, immutable_1.Seq)(generator(start));
};
// Generator
function generator(current, initial) {
  var x;
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return current;

        case 2:
          x = initial || current;
          return _context.delegateYield(generator(current * x, x), "t0", 4);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=power.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/power.js
// module id = 279
// module chunks = 0